import Navigator from 'app';
import NavbarLayout from './views/navbar_layout';
import NavlinkCollectionView from './views/navlink_collection_view';
import '../../entities/navlink/navlink_collection';
export default {
  showNavbar: function () {
    var navbarLayout = new NavbarLayout();
    var navlinks = Navigator.request("navlinks");
    var navlinkCollectionView = new NavlinkCollectionView({
      collection: navlinks
    });
    navbarLayout.on("show", function () {
      navbarLayout.navlinkRegion.show(navlinkCollectionView);
    });
    navlinkCollectionView.on("childview:navigate", function (childView, model) {
      var trigger = model.get("navigationTrigger");
      Navigator.vent.trigger(trigger);
    });
    Navigator.navbarRegion.show(navbarLayout);
  }
};